import Icon from 'components/icons/Icon';
import { ExternalPaymentWrapper } from 'hooks/useExternalPaymentMethods';
import { useMemo } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';
import { useUiStore } from 'stores/uiStore';

const PADDING = 20;

const InfoIcon: React.FC = () => <Icon name="Info-Outlined" />;

const IconWrapper = styled.View`
  margin-right: -${PADDING}px;
`;

const ExternalPaymentInfoButton: React.FC<{ item: ExternalPaymentWrapper }> = ({
  item,
}) => {
  const modal = useMemo(() => {
    if (item.externalPaymentType === 'SWISH') {
      return 'swishInfo';
    }
  }, [item.externalPaymentType]);

  if (modal) {
    return (
      <TouchableOpacity
        style={[styles.touch]}
        onPress={() => useUiStore.getState().setSheetModal(modal)}>
        <IconWrapper>
          <InfoIcon />
        </IconWrapper>
      </TouchableOpacity>
    );
  }
  return <></>;
};

export default ExternalPaymentInfoButton;

const styles = StyleSheet.create({
  touch: {
    paddingTop: PADDING / 4,
    paddingBottom: PADDING / 4,
    paddingLeft: PADDING,
    paddingRight: PADDING,
  },
});
